const drawerDetails = document.querySelector('header-drawer > details');
if (drawerDetails && window.innerWidth < 990) {
  const lang = document.querySelector('localization-form');
  const search = document.querySelector('.header__search');
  const icons = document.querySelector('.header__icons');
  icons.insertBefore(lang, search);
}


const productColors = document.querySelectorAll('.product__colors');
const sizeMap = {};

if (productColors.length) {
  let currentSize = {};
  productColors.forEach((colorSet) => {
    const colorSetNumber = checkSetNumber(colorSet);

    const swatches = colorSet.querySelectorAll('.color-swatch__item');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const colorName = swatch.dataset.colorname || '';
        const legend = swatch.closest('.product__colors').querySelector('.product__colors-legend');
        const colorNameElement = legend.querySelector('.colorname');
       if (colorNameElement) {
          colorNameElement.innerHTML = colorName
            ? `&nbsp;|&nbsp;<span class="color-text">${colorName}</span>`
            : '';
        }

        // Remove 'selected' only within this color set
        swatches.forEach((s) => s.classList.remove('selected'));
        swatch.classList.add('selected');
        colorSet.classList.remove('error');
        
        // Update preview image based on selected swatch
        const preview = document.querySelector(`.yarn-preview[data-set="${colorSetNumber}"]`);
        if (preview) {
          const newVariantId = swatch.dataset.variantId;
          const newActivePreview = preview.querySelector(`img[data-variant-id="${newVariantId}"]`);
          preview.querySelector('img.active').classList.remove('active');
          newActivePreview.classList.add('active');
        }
        // Use mapped currentSize per set
        swatch.dataset.sizevalue = currentSize[colorSetNumber] || '';
        filterByCommittedStock();
        const swatchModalImage = document.querySelector(`.swatch-modal[data-set="${colorSetNumber}"]`);
        if (swatchModalImage) {
          swatchModalImage.querySelector('img').src = swatch.dataset.imageUrl || '';
        } else {
          // Create a modal element for swatch image preview
          const modal = document.createElement('div');
          modal.dataset.set = colorSetNumber;
          modal.className = 'swatch-modal';
          modal.innerHTML = '<img src="' + (swatch.dataset.imageUrl || '') + '">';
          document.body.appendChild(modal);
          modal.addEventListener('click', () => {
            modal.style.display = 'none';
          });
          document.querySelector(`.swatch-modal-icon .modal-container[data-set="${colorSetNumber}"]`).classList.remove('hidden');
        }
      });
    });
  });

  const colornames = document.querySelectorAll('.product__colors-legend .colorname');
  colornames.forEach((el) => {
    el.addEventListener('click', () => {
      const setNumber = el.dataset.set;
      const modal = document.querySelector(`.swatch-modal[data-set="${setNumber}"]`);
      if (modal) {
        modal.style.display = 'flex';
      }
    });
  });
  
  const modalSearchIcons = document.querySelectorAll('.swatch-modal-icon .modal-container');
  modalSearchIcons.forEach((el) => {
    el.addEventListener('click', () => {
      const setNumber = el.dataset.set;
      const modal = document.querySelector(`.swatch-modal[data-set="${setNumber}"]`);
      if (modal) {
        modal.style.display = 'flex';
      }
    });
  });

  function updateCurrentSize() {
    const selectedSwatches = document.querySelectorAll('.color-swatch__item.selected');
    selectedSwatches.forEach((swatch) => {
      const colorSet = +swatch.dataset.colorSet;
      const sizeValue = currentSize[colorSet] || '';
      swatch.dataset.sizevalue = sizeValue;
    });
  }

  const productSizeLabels = document.querySelectorAll('.form__label');
  const productColorSets = document.querySelectorAll('.product__colors');



  if (productSizeLabels.length && productColorSets.length) {
    // Build size maps per color set
    productColorSets.forEach((set) => {
      const setNumber = checkSetNumber(set);

      const dataSizes = set.getAttribute('data-sizes');
      if (dataSizes) {
        const map = Object.fromEntries(
          dataSizes
            .split(',')
            .map(pair => {
            const trimmedPair = pair.trim();
            const colonIndex = trimmedPair.indexOf(':');
            if (colonIndex === -1) return [];
            const key = trimmedPair.substring(0, colonIndex).trim();
            const value = trimmedPair.substring(colonIndex + 1).trim();
            return [key, value];
          })
          .filter(Boolean)

        );
        sizeMap[setNumber] = map;
      }
    });

    const infoContainer = document.querySelector('.product__info-container');
    infoContainer.addEventListener('click', (e) => {
      if (e.target.dataset.size) {
        const size = e.target.value;

        productColors.forEach((colorSet) => {
            const setNumber = checkSetNumber(colorSet);
            const map = sizeMap[setNumber] || {};
            const sizeNumber = map[size];
            if (!sizeNumber) {
              console.log(`Size "${size}" not found in sizeMap for set ${setNumber}. Showing all colors.`);
              showAllColors(setNumber);
              currentSize[setNumber] = null;
            } else {
              filterColorsBySize(sizeNumber, setNumber);
              checkIfAvailable(setNumber, sizeNumber);
              currentSize[setNumber] = sizeNumber;
            }
        });
        updateCurrentSize();
      }
    });

    checkColorsOnLoad();
  }
  

  function checkSetNumber(colorSet) {
    let number = 1;
    if (colorSet.classList.contains('product__colors--set-2')) {
      number = 2;
    } else if (colorSet.classList.contains('product__colors--set-3')) {
      number = 3;
    } else if (colorSet.classList.contains('product__colors--set-4')) {
      number = 4;
    }
    return number;
  }


  function checkColorsOnLoad() {
    const selectedSizeInputs = document.querySelectorAll('.product-form__input > input:checked');

    selectedSizeInputs.forEach((input) => {
      if (input.dataset.size) {
        const size = input.value;
        productColors.forEach((colorSet) => {
          const setNumber = checkSetNumber(colorSet);
            const map = sizeMap[setNumber] || {};
            const sizeNumber = map[size];
            if (!sizeNumber) {
              console.log(`Size "${size}" not found in sizeMap for set ${setNumber}. Showing all colors.`);
              showAllColors(setNumber);
              currentSize[setNumber] = null;
            } else {
              filterColorsBySize(sizeNumber, setNumber);
              checkIfAvailable(setNumber);
              currentSize[setNumber] = sizeNumber;
            }
        });
        updateCurrentSize();
      }
    });
  }



  function filterColorsBySize(size, setNumber) {
    const colorSwatches = document.querySelectorAll(`.color-swatch__item[data-color-set="${setNumber}"]`);
    const legend = document.querySelector(`.product__colors--set-${setNumber} .set-quantity`);
    const amount = legend ? legend.getAttribute('data-amount') : '';
    if (legend) {
      legend.textContent = ` - ${size} ${amount}`;
    }
    let stock = false;
    colorSwatches.forEach((swatch) => {
      const swatchQuantity = parseInt(swatch.getAttribute('data-quantity'), 10);
      if (swatchQuantity >= size) {
        stock = true;
        swatch.style.display = 'inline-block';
      } else {
        swatch.style.display = 'none';
      }
    });
    const noStockMessage = colorSwatches[0].closest('.product__colors').querySelector('.no-stock-message');
    if (!stock) {
      noStockMessage.classList.remove('hidden');
    } else {
      noStockMessage.classList.add('hidden');
    }
  }


  function checkIfAvailable(setNumber, sizeNumber) {
    const selectedSwatch = document.querySelector(`.color-swatch__item.selected[data-color-set="${setNumber}"]`);

    if (selectedSwatch && selectedSwatch.style.display === 'none') {
      selectedSwatch.classList.remove('selected');

      const visibleSwatches = document.querySelectorAll(`.color-swatch__item[data-color-set="${setNumber}"][style*="display: inline-block"]`);
      if (visibleSwatches.length > 0) {
        const newSwatch = visibleSwatches[0];
        newSwatch.classList.add('selected');
        if (sizeNumber) newSwatch.dataset.sizevalue = sizeNumber;

        // Update color text
        const colorSet = newSwatch.closest('.product__colors');
        const colorNameElement = colorSet.querySelector('.product__colors-legend .colorname');
        if (colorNameElement) {
          const colorName = newSwatch.dataset.colorname || '';
          colorNameElement.innerHTML = colorName
            ? `&nbsp;|&nbsp;<span class="color-text">${colorName}</span>`
            : '';
        }

        // Update yarn preview
        const preview = document.querySelector(`.yarn-preview[data-set="${setNumber}"]`);
        if (preview) {
          const activeImg = preview.querySelector('img.active');
          if (activeImg) activeImg.classList.remove('active');
          const newActivePreview = preview.querySelector(`img[data-variant-id="${newSwatch.dataset.variantId}"]`);
          if (newActivePreview) newActivePreview.classList.add('active');
        }
      }
    }
    filterByCommittedStock();
  }


  function showAllColors(setNumber) {
    const colorSwatches = document.querySelectorAll(`.color-swatch__item[data-color-set="${setNumber}"]`);

    colorSwatches.forEach((swatch) => {
      if (parseInt(swatch.dataset.quantity, 10) > 0) {
        swatch.style.display = 'inline-block';
      } else {
        swatch.style.display = 'none';
      }
    });
  }

  function filterByCommittedStock() {
    productColors.forEach((colorSet) => {
      const setNumber = checkSetNumber(colorSet);
      const sizeRequired = parseInt(currentSize[setNumber]) || 0;
      if (!sizeRequired) return;

      // Sum committed quantity per variant from all OTHER sets
      const otherCommitted = {};
      productColors.forEach((otherSet) => {
        if (checkSetNumber(otherSet) === setNumber) return;
        const sel = otherSet.querySelector('.color-swatch__item.selected');
        if (!sel) return;
        const vid = sel.dataset.variantId;
        const qty = parseInt(sel.dataset.sizevalue) || 0;
        otherCommitted[vid] = (otherCommitted[vid] || 0) + qty;
      });

      colorSet.querySelectorAll('.color-swatch__item').forEach((swatch) => {
        const stock = parseInt(swatch.dataset.quantity) || 0;
        const othersNeed = otherCommitted[swatch.dataset.variantId] || 0;
        // Determine correct visibility: hidden if not enough stock for size alone,
        // or not enough remaining after other sets' commitments
        const shouldHide = stock < sizeRequired || stock - othersNeed < sizeRequired;
        swatch.style.display = shouldHide ? 'none' : 'inline-block';

        if (shouldHide && swatch.classList.contains('selected')) {
          swatch.classList.remove('selected');
          const visible = colorSet.querySelectorAll('.color-swatch__item[style*="display: inline-block"]');
          if (visible.length > 0) {
            visible[0].classList.add('selected');
            visible[0].dataset.sizevalue = currentSize[setNumber];
            const colorNameEl = colorSet.querySelector('.product__colors-legend .colorname');
            if (colorNameEl) {
              const cn = visible[0].dataset.colorname || '';
              colorNameEl.innerHTML = cn ? `&nbsp;|&nbsp;<span class="color-text">${cn}</span>` : '';
            }
            const preview = document.querySelector(`.yarn-preview[data-set="${setNumber}"]`);
            if (preview) {
              const active = preview.querySelector('img.active');
              if (active) active.classList.remove('active');
              const newActive = preview.querySelector(`img[data-variant-id="${visible[0].dataset.variantId}"]`);
              if (newActive) newActive.classList.add('active');
            }
          }
        }
      });
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const colorWrappers = document.querySelectorAll('.color-wrapper');

  colorWrappers.forEach((wrapper, index) => {
    const previewContainer = wrapper.querySelector('.yarn-preview');
    if (!previewContainer) return;

    const previewImages = previewContainer.querySelectorAll('img');
    const swatches = wrapper.querySelectorAll('.color-swatch__item');
    const modalIcon = wrapper.querySelector('.swatch-modal-icon .modal-container');
    if (!previewImages.length || !swatches.length) return;

    // --- modal setup for this wrapper ---
    let modal = null;
    if (modalIcon) {
      // make icon visible
      modalIcon.classList.remove('hidden');

      // create a dedicated modal for this wrapper
      modal = document.createElement('div');
      modal.className = 'swatch-modal';
      modal.dataset.wrapperIndex = index;
      modal.innerHTML = `<img src="${previewImages[0].src}" alt="">`;
      modal.style.display = 'none';
      document.body.appendChild(modal);

      // close on click
      modal.addEventListener('click', () => {
        modal.style.display = 'none';
      });

      // open on icon click
      modalIcon.addEventListener('click', () => {
        const activeImg =
          previewContainer.querySelector('img.active') || previewImages[0];
        modal.querySelector('img').src = activeImg.src;
        modal.style.display = 'flex';
      });
    }

    function setActivePreviewByVariantId(variantId, fallbackUrl) {
      if (!previewImages.length) return;

      // Clear existing active
      previewImages.forEach((img) => img.classList.remove('active'));

      // Try to find a preview img with matching data-variant-id
      if (variantId) {
        const match = previewContainer.querySelector(
          `img[data-variant-id="${variantId}"]`
        );
        if (match) {
          match.classList.add('active');
          return;
        }
      }

      // Fallback: just update the first preview image src
      if (fallbackUrl) {
        const first = previewImages[0];
        first.src = fallbackUrl;
        first.classList.add('active');
      } else {
        // if nothing else, just re-activate first
        previewImages[0].classList.add('active');
      }
    }

    function selectSwatch(swatch) {
      swatches.forEach((s) => s.classList.remove('selected'));
      swatch.classList.add('selected');

      const input = swatch.querySelector('.color-swatch__input');
      if (input && !input.checked) {
        input.checked = true;
        // let Shopify’s variant-radios listen to this
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const variantId = swatch.dataset.variantId;
      const imageUrl = swatch.dataset.imageUrl;
      setActivePreviewByVariantId(variantId, imageUrl);
    }

    // Click handlers for swatches
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        selectSwatch(swatch);
      });

      const input = swatch.querySelector('.color-swatch__input');
      if (input) {
        input.addEventListener('change', () => {
          if (input.checked) {
            selectSwatch(swatch);
          }
        });
      }
    });

    // Initial state: pick checked radio if any
    const checkedInput = wrapper.querySelector('.color-swatch__input:checked');
    if (checkedInput) {
      const swatch = checkedInput.closest('.color-swatch__item');
      if (swatch) selectSwatch(swatch);
    } else if (swatches.length) {
      // otherwise, default to first swatch
      selectSwatch(swatches[0]);
    }
  });
});


// Update text for "Color" label in product forms
document.addEventListener('DOMContentLoaded', () => {
  const label = document.querySelector('.product-form__color-label');
  if (label) {
    const activeColor = document.querySelector('.color-swatch__item.selected input');
    if (activeColor) {
      label.textContent = `${label.dataset.colorLabel} - ${activeColor.value}`;
    } else {
      label.textContent = label.dataset.colorLabel;
    }
  }
  const colorSwatchItems = document.querySelectorAll('.color-swatch__item');
  if (!colorSwatchItems) return;
  colorSwatchItems.forEach((item) => {
    item.addEventListener('click', () => {
      const value = item.querySelector('input').value;
      if (value && label) {
        label.textContent = `${label.dataset.colorLabel} - ${value}`;
      }
    });
  });
});


/* Spektakelstrik: clickable image banners */
const setupClickableImageBanners = (root = document) => {
  const primaryLink = document.querySelector(
    '#Banner-template--29979520074115__image_banner .banner__heading a[href]'
  );

  root.querySelectorAll('.banner').forEach((banner) => {
    const sourceLink =
      banner.querySelector('.banner__heading a[href]') ||
      (banner.id === 'Banner-template--29979520074115__image_banner_rQipRt' ? primaryLink : null);

    if (!sourceLink || banner.querySelector(':scope > .banner__whole-link')) return;

    const overlayLink = document.createElement('a');
    overlayLink.className = 'banner__whole-link';
    overlayLink.href = sourceLink.href;
    overlayLink.setAttribute('aria-label', sourceLink.textContent.trim());
    banner.classList.add('banner--whole-link-ready');
    banner.prepend(overlayLink);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupClickableImageBanners());
} else {
  setupClickableImageBanners();
}

document.addEventListener('shopify:section:load', (event) => {
  setupClickableImageBanners(event.target);
});
